// Generated by ScalaTS 0.8.2: https://scala-ts.github.io/scala-ts/

declare var exports: any;

export const nsCancelled = exports;

export const CancelledInhabitant = 'Cancelled';

export type Cancelled = typeof CancelledInhabitant;

export function isCancelled(v: any): v is Cancelled {
  return CancelledInhabitant == v;
}

export type CancelledSingleton = Cancelled;
